import { useEffect } from "react";
import "swiper/css";
import Aos from "aos";
import Router from "./router/Router";
import { Cookies } from "./components";
import Providers from "./context";
import { client_selected } from "./client";

const App = () => {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <Providers>
      {client_selected.hasClarity ? <Cookies /> : null}
      <Router />
    </Providers>
  );
};

export default App;
